import { render, staticRenderFns } from "./Sponsor.vue?vue&type=template&id=a2450c18"
import script from "./Sponsor.vue?vue&type=script&lang=js"
export * from "./Sponsor.vue?vue&type=script&lang=js"
import style0 from "./Sponsor.vue?vue&type=style&index=0&id=a2450c18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports